<script>
import SalesFilter from "@/components/sale/SalesFilter.vue";
import SalesBase from "./SalesBase.vue";

export default {
  extends: SalesBase,
  data() {
    return {
      filterModal: SalesFilter
    };
  }
};
</script>
